













import {Component, Prop, Vue} from "vue-property-decorator";
import {Store} from "@/enums/Store";
import {Member} from "@/util/Member";
import {namespace} from 'vuex-class';
import {formatPriceByCurrency} from "@/util/price";
import {Locale} from "@/enums/Locale";
import {OrderItem} from "@/util/OrderItem";
import FormSelect from "@/components/Form/InputComponents/FormSelect.vue";
import {Option} from "@/util/Option";
import {Event} from "@/util/Event";
import {TicketCategory} from "@/util/TicketCategory";
import {Currency} from "@/enums/Currency";

const APP = namespace(Store.APP);
const CART = namespace(Store.CART);
const EVENT = namespace(Store.EVENT);
const MEMBER = namespace(Store.MEMBER);

@Component({
  components: {FormSelect}
})
export default class MemberOverview extends Vue {
  @Prop({default: true}) showMemberButtons!: boolean;
  @Prop({required: true}) member!: Member;
  @Prop({required: true}) index!: number;
  @APP.State('locale') locale!: Locale;
  @APP.State('currency') currency!: Currency;
  @CART.Getter('orderItem') orderItem!: (member: Member) => OrderItem;
  @MEMBER.Action('removeMember') removeMember!: (member: Member) => void;
  @EVENT.Getter('selectedEventObject') event?: Event;

  get options(){
    if (this.event) {
      return this.event.ticketCategories.map(({entityId, price}: TicketCategory) => {
        const orderItem = this.orderItem(this.member);
        if(this.member.ticketCategoryId == entityId){
          return new Option(formatPriceByCurrency(orderItem.price, this.currency), entityId)
        }
        return new Option(formatPriceByCurrency(price, this.currency), entityId)
      });
    }
    return []
  }

  get formatedPrice(): string {
    const orderItem = this.orderItem(this.member);
    if (!orderItem) {
      return '';
    }

    return formatPriceByCurrency(orderItem.price, this.currency)
  }

  get name() {
    if (!this.member.firstname && !this.member.lastname) {
      return this.$t('member', {index: this.index + 1})
    }

    return `${this.member.firstname || ''} ${this.member.lastname || ''}`
  }
}
